import React from "react";
import { Input as input } from "antd";

type SetStateAction = React.Dispatch<React.SetStateAction<string>>;
type FormField = {
  label: string;
  value: string;
  handler: SetStateAction;
  inputAsTextArea?: boolean;
};
interface Props {
  fields: FormField[];
}

const OrganizationDetailsForm: React.FC<Props> = ({ fields }) => {
  const renderFormField = ({ label, value, handler, inputAsTextArea }: FormField, idx: number) => {
    const Input = inputAsTextArea ? input.TextArea : input;
    return (
      <div className="address-form-row" key={label + "-" + idx}>
        <Input
          placeholder={label}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => handler(e.target.value)}
          rows={4}
          allowClear
        />
      </div>
    );
  };

  return (
    <div className="address-form">
      <h3 className="header">ORGANIZATION DETAILS</h3>
      {fields.map(renderFormField)}
    </div>
  );
};

export default OrganizationDetailsForm;
